const RemoteExtensionsScannerChannelName = 'remoteExtensionsScanner';

export { RemoteExtensionsScannerChannelName };
